import { getAppEnv } from '@/constants/enums/app-env.enum'

const LOG_PREFIX = '[ScreeningProctoring]'

function isDebugEnabled(): boolean {
    return getAppEnv() !== 'prod'
}

/** Console info for FastRTC proctoring/face diagnostics. No-ops when APP_ENV === prod. */
export function debugScreeningProctoringLog(message: string, ...args: unknown[]): void {
    if (!isDebugEnabled()) {
        return
    }
    if (args.length > 0) {
        console.info(LOG_PREFIX, message, ...args)
        return
    }
    console.info(LOG_PREFIX, message)
}

/** Console warn for FastRTC proctoring/face diagnostics. No-ops when APP_ENV === prod. */
export function debugScreeningProctoringWarn(message: string, ...args: unknown[]): void {
    if (!isDebugEnabled()) {
        return
    }
    if (args.length > 0) {
        console.warn(LOG_PREFIX, message, ...args)
        return
    }
    console.warn(LOG_PREFIX, message)
}
